import type {
  Notification,
  NotificationListResponse,
  NotificationUnreadCountResponse,
  PushSubscriptionPayload,
  VapidPublicKeyResponse
} from '@tandemone/types'

import { api } from '@/api/client'

export async function listNotifications(
  opts: {
    cursor?: string
    limit?: number
    unreadOnly?: boolean
    since?: string
  },
  signal?: AbortSignal
): Promise<NotificationListResponse> {
  const { data } = await api.get<NotificationListResponse>(
    '/v1/notifications',
    {
      params: opts,
      signal
    }
  )
  return data
}

export async function fetchUnreadCount(
  signal?: AbortSignal
): Promise<NotificationUnreadCountResponse> {
  const { data } = await api.get<NotificationUnreadCountResponse>(
    '/v1/notifications/unread-count',
    { signal }
  )
  return data
}

export async function markNotificationRead(
  id: Notification['id']
): Promise<void> {
  await api.post(`/v1/notifications/${id}/read`)
}

export async function markAllNotificationsRead(): Promise<{ updated: number }> {
  const { data } = await api.post<{ updated: number }>(
    '/v1/notifications/read-all'
  )
  return data
}

export async function dismissNotification(
  id: Notification['id']
): Promise<void> {
  await api.delete(`/v1/notifications/${id}`)
}

export async function fetchVapidPublicKey(): Promise<string> {
  const { data } = await api.get<VapidPublicKeyResponse>(
    '/v1/push-subscriptions/vapid-public-key'
  )
  return data.publicKey
}

export async function registerPushSubscription(
  payload: PushSubscriptionPayload
): Promise<void> {
  await api.post('/v1/push-subscriptions', payload)
}

export async function unregisterPushSubscription(
  endpoint: string
): Promise<void> {
  await api.delete('/v1/push-subscriptions', { data: { endpoint } })
}
